<template>
  <div class="table__rows-container">
    <div
      v-for="item in data"
      :key="item.field"
      class="table__row"
      :class="rowClass"
    >
      <!-- 1 -->
      <div>
        <span>{{ item.field }}</span>
      </div>

      <!-- 2 -->
      <div>
        <span
          class="link"
          v-if="item.field == 'Ethereum TX HASH'"
          @click="etherscan(item.value)"
        >{{ item.value }}</span>
        <span v-else>{{ item.value }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { etherScanUrl } from "../../../js/wpci";

export default {
  props: ["data", "rowClass"],
  methods: {
    etherscan(txhash) {
      window.open(etherScanUrl + "/tx/" + txhash)
    }
  }
};
</script>

<style scoped lang="scss">
.link {
  font-weight: 700;
  color: #0393f4;
  cursor: pointer;
  text-decoration: underline;
}
</style>


// WEBPACK FOOTER //
// src/components/contents/shared/TableSlotUnwrap.vue